import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesServicesCausesListComponent } from './cases-services-causes-list/cases-services-causes-list.component';
import { CasesServicesCausesDetailComponent } from './cases-services-causes-detail/cases-services-causes-detail.component';

const routes: Routes = [
    {
        path: 'casesServicesCauses',
        children: [
            { path: '', component: CasesServicesCausesListComponent }
        ]
    },
    {
        path: 'casesServicesCauses/:id',
        children: [
            { path: '', component: CasesServicesCausesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],

    exports: [RouterModule]
})
export class CasesServicesCausesRoutingModule { }
